var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_18416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.233 50.7992C40.2608 50.7992 51.6326 39.4274 51.6326 25.3997C51.6326 11.3719 40.2608 0.000106812 26.233 0.000106812C12.2053 0.000106812 0.833496 11.3719 0.833496 25.3997C0.833496 39.4274 12.2053 50.7992 26.233 50.7992Z",
    fill: "#37437D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8547 10.861H15.6139C13.4501 10.861 11.6958 12.6151 11.6958 14.7791V36.0199C11.6958 38.1839 13.45 39.938 15.6139 39.938H26.0896L26.1078 29.5478H23.4081C23.0572 29.5478 22.7725 29.264 22.7713 28.9132L22.7581 25.5637C22.7567 25.2112 23.0426 24.9244 23.3951 24.9244H26.09V21.6881C26.09 17.9326 28.3837 15.8876 31.7339 15.8876H34.4832C34.8347 15.8876 35.1201 16.1728 35.1201 16.5246V19.3486C35.1201 19.7004 34.835 19.9856 34.4836 19.9856L32.7963 19.9866C30.9744 19.9866 30.6213 20.8522 30.6213 22.123V24.9248H34.6248C35.0066 24.9248 35.3025 25.258 35.2574 25.6365L34.8604 28.9859C34.8226 29.3066 34.5506 29.548 34.2279 29.548H30.6394L30.6212 39.9386H36.8546C39.0185 39.9386 40.7727 38.1842 40.7727 36.0204V14.7791C40.7728 12.6152 39.0186 10.861 36.8547 10.861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0895 39.9378L26.1078 29.5476H26.063V39.9378H26.0895Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_18416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.7993,
    height: 50.7993,
    fill: "white",
    transform: "translate(0.833496 9.15527e-05)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7bebd5099ebfaf56f0d7957c616794b9.svg";
export { ForwardRef as ReactComponent };